import { render, staticRenderFns } from "./DataCardSkeleton.vue?vue&type=template&id=500bb6dd&scoped=true&"
import script from "./DataCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./DataCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./DataCardSkeleton.vue?vue&type=style&index=0&id=500bb6dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500bb6dd",
  null
  
)

export default component.exports